<template>
    <div>
        <ContentHeader :disabled="false" :title="lang('singleFlashCardFirstTitle',language)"
                       :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin size="large" fix v-if="mainDataLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleFlashCardFirstMainTitle',language)}}
            </p>
            <Row>
                <Col :span="index == 1?8:4"
                     :class="[index == lang('singleFlashCardFirstMainTip',language).length-1?'':'mainDataCol']"
                     v-for="(item,index) in lang('singleFlashCardFirstMainTip',language)">
                    <p class="mainDataTitle">{{item}}</p>
                    <p class="mainDataItem">
                        <template v-if="lang('singleFlashCardFirstMainKey',language)[index] == 'lfAccuracyRating'">
                            {{mainData[lang('singleFlashCardFirstMainKey',language)[index]] * 100 | numFilter}}
                        </template>
                        <template v-else>
                            {{mainData[lang('singleFlashCardFirstMainKey',language)[index]]}}
                        </template>
                        <span class="mainDataUnit">{{lang('singleFlashCardFirstMainUnit',language)[index]}}</span>
                    </p>
                </Col>
            </Row>
        </Card>
        <br/>
        <Row>
            <Col span="24">
                <Card :style="{textAlign:'left'}">
                    <RadioGroup v-model="type" type="button" @on-change="changeDataType">
                        <Radio :label="index" size="large"
                               v-for="(item,index) in lang('singleFlashCardFirstItemType',language)" :key="index">
                            {{item}}
                        </Radio>
                    </RadioGroup>
                </Card>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <SelectDate @increase="getDateRange"/>
                <Card>
                    <Spin size="large" fix v-if="itemDataLoading"></Spin>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{dataTypeTitle}}
                    </p>
                    <template v-if="type == 0">
                        <BarChart :bar_chart_data="lccChartData" v-if="JSON.stringify(lccChartData) !== '{}'"
                                  :changeCount="lccChartChangeCount"/>
                    </template>
                    <template v-if="type == 1">
                        <div :style="{position:'relative'}">
                            <Table show-header border :columns="speakingColumnArr" :data="speakingData"></Table>
                        </div>
                        <br>
                        <Page :total="speakingDataTotal" show-sizer show-total show-elevator @on-change="changePage"
                              :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                              @on-page-size-change="changePageSize" placement="top" width=""
                              v-if="speakingData.length>0"></Page>
                    </template>
                    <template v-if="type == 2">
                        <BarChart :bar_chart_data="lrChartData" v-if="JSON.stringify(lrChartData) !== '{}'"
                                  :changeCount="lrChartChangeCount"/>
                    </template>
                    <template v-if="type == 3">
                        <div :style="{position:'relative'}">
                            <Table show-header border :columns="lfColumnArr" :data="lfData"></Table>
                        </div>
                        <br>
                        <Page :total="lfDataTotal" show-sizer show-total show-elevator @on-change="changePage"
                              :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                              @on-page-size-change="changePageSize" placement="top" width=""
                              v-if="lfData.length>0"></Page>
                    </template>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import TeacherJob from "./StudentJob";

    var _hmt = _hmt || [];
    (function () {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import SelectDate from '@/components/SelectDate.vue';
    import {getSingleData} from '@/utils/net.js';
    import BarChart from '@/components/BarChart.vue';

    var that = null;
    export default {
        name: "FlashCard1",
        store,
        components: {
            TeacherJob,
            ContentHeader,
            SelectDate,
            BarChart
        },
        data() {
            return {
                lang: lang,
                headerTipArr: [],
                stateLang: '',
                mainDataLoading: false,
                itemDataLoading: false,
                mainData: {},
                type: 0,
                dataTypeTitle: "",
                lccChartChangeCount: 0,
                lccChartData: {},
                lrChartChangeCount: 0,
                lrChartData: {},

                speakingData: [],
                speakingDataTotal: 0,
                speakingColumnArr: [],
                lfData: [],
                lfDataTotal: 0,
                lfColumnArr: [],
                page: 1,
                pageSize: 20,
                start: '',
                end: '',
            }
        },
        beforeCreate() {
            that = this;
        },
        mounted() {
            that.dataTypeTitle = that.lang('singleFlashCardFirstDataType', that.language)[0];
            that.getSpeakingTableHeader();
            that.getLfTableHeader();
            that.loadHeaderTipArr();
            that.getFcPrimary();
            that.changeDataType(0);

        },
        methods: {
            loadHeaderTipArr() {
                let arr = [];
                for (var i = 0; i < that.lang('singleFlashCardFirstHeaderTipTitle', this.language).length; i++) {
                    var item = {};
                    item.title = that.lang('singleFlashCardFirstHeaderTipTitle', this.language)[i];
                    item.content = that.lang('singleFlashCardFirstHeaderTipContent', this.language)[i];
                    if (JSON.stringify(item) !== '') {
                        arr.push(item);
                    }
                }
                that.headerTipArr = arr;
            },
            getFcPrimary() {
                that.mainDataLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/fc/primary/person',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.mainData = retMap;
                        that.mainDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.mainDataLoading = false;
                    }
                })
            },

            // 获取汉字通学习的图表数据
            getLccChart() {
                that.itemDataLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/fc/chart/lcc/person',
                    params: {
                        start: that.start,
                        end: that.end,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        var data = retMap.data[0].data;
                        var xAxisArr = [];
                        var seriesData = [];
                        for (var key in data) {
                            xAxisArr.push(data[key].word);
                            seriesData.push(data[key].times);
                        }
                        that.lccChartData.yAxisFormatter = function (value, index) {
                            return value + '次';
                        }
                        that.lccChartData.xAxisArr = xAxisArr;
                        that.lccChartData.seriesData = seriesData;
                        that.lccChartChangeCount++;
                        that.itemDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.itemDataLoading = false;
                    }
                })
            },
            getSpeakingTableHeader() {
                var arr = that.lang('singleFlashCardFirstSpeakingTableColumnTitle', that.language);
                var arr1 = that.lang('singleFlashCardFirstSpeakingTableColumnKey', that.language);
                var tempArr = [];
                for (let i = 0; i < arr.length; i++) {
                    var item = {};
                    item.title = arr[i];
                    item.key = arr1[i];
                    tempArr.push(item);
                }
                that.speakingColumnArr = tempArr;
            },
            // 获取说一说数据
            getSpeakingData() {
                that.itemDataLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/fc/speaking/daily/person',
                    params: {
                        page: that.page,
                        pageSize: that.pageSize,
                        start: that.start,
                        end: that.end,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.speakingDataTotal = retMap.total;
                        that.speakingData = retMap.list;
                        that.itemDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.itemDataLoading = false;
                    }
                })
            },

            // 获取小聆龙识字的数据
            getLrChart() {
                that.itemDataLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/fc/chart/lr/person',
                    params: {
                        start: that.start,
                        end: that.end,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        var data = retMap.data[0].data;
                        var xAxisArr = [];
                        var seriesData = [];
                        for (var key in data) {
                            xAxisArr.push(data[key].word);
                            seriesData.push(data[key].times);
                        }
                        that.lrChartData.yAxisFormatter = function (value, index) {
                            return value + '次';
                        }
                        that.lrChartData.xAxisArr = xAxisArr;
                        that.lrChartData.seriesData = seriesData;
                        that.lrChartChangeCount++;
                        that.itemDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.itemDataLoading = false;
                    }
                })
            },

            getLfTableHeader() {
                var arr = that.lang('singleFlashCardFirstLfTableColumnTitle', that.language);
                var arr1 = that.lang('singleFlashCardFirstLfTableColumnKey', that.language);
                var tempArr = [];
                for (let i = 0; i < arr.length; i++) {
                    var item = {};
                    item.title = arr[i];
                    item.key = arr1[i];
                    tempArr.push(item);
                }
                that.lfColumnArr = tempArr;
            },

            // 获取小聆龙听音找字数据
            getLfData() {
                that.itemDataLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/fc/lf/daily/person',
                    params: {
                        page: that.page,
                        pageSize: that.pageSize,
                        start: that.start,
                        end: that.end,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.lfDataTotal = retMap.total;
                        var arr = retMap.list;
                        if(arr.length>0){
                            for(let index in arr){
                                arr[index].rating = Number(arr[index].rating*100)+"%"
                            }
                        }
                        that.lfData = arr;
                        that.itemDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.itemDataLoading = false;
                    }
                })
            },
            getDateRange(data) {
                that.start = data.t2;
                that.end = data.t1;
                that.getData();
            },
            getData() {
                switch (that.type) {
                    case 0:
                        that.getLccChart();
                        break;
                    case 1:
                        that.getSpeakingData();
                        break;
                    case 2:
                        that.getLrChart();
                        break;
                    case 3:
                        that.getLfData();
                        break;
                }
            },
            changeDataType(index) {
                that.type = index;
                that.page = 1;
                that.pageSize = 20;
                that.getData()
            },
            changePage(page) {
                that.page = page;
                that.getData();
            },
            changePageSize(pageSize) {
                that.pageSize = pageSize;
                that.getData();
            },
        },
        watch: {
            type: function (val) {
                that.dataTypeTitle = that.lang('singleFlashCardFirstDataType', that.language)[val]
            }
        },

        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },


        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }
    }
</script>

<style scoped>
    .mainDataCol {
        border-right: 1px solid #E8E9F2;
    }

    .mainDataTitle {
        color: #4F6B87
    }

    .mainDataItem {
        font-family: ArialMT;
        color: #595959;
        font-size: 36px
    }

    .mainDataUnit {
        font-size: 18px;
    }
</style>
